import anime from "animejs";
import ThemeKit from "../../theme";

export const createLoadingTimeline = (): anime.AnimeTimelineInstance => {
  return anime.timeline({
    targets: ".submit-outage-button",
    endDelay: 250,
    easing: "linear",
    loop: true,
  });
};

export const animateLoading = (timeline: anime.AnimeTimelineInstance): void => {
  timeline
    .add({
      backgroundColor: ThemeKit.CE_THEME.colors.cta.primary,
      delay: 250,
    })
    .add({
      backgroundColor: ThemeKit.CE_THEME.colors.essential.buttonGreen,
    });
};
